import { render, staticRenderFns } from "./brandsFilter.vue?vue&type=template&id=7e770c70&scoped=true&"
import script from "./brandsFilter.vue?vue&type=script&lang=js&"
export * from "./brandsFilter.vue?vue&type=script&lang=js&"
import style0 from "./brandsFilter.vue?vue&type=style&index=0&id=7e770c70&lang=scss&scoped=true&"
import style1 from "./brandsFilter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e770c70",
  null
  
)

export default component.exports